import cookie from 'cookie';
import moment from 'moment-timezone';

const defaultOptions = {
  path: '/',
};

const Cookies = {

  set(key, value, days) {
    const options = Object.assign({}, defaultOptions, {
      expires: moment().add(days, 'days').toDate(),
    });
    const cookieToSet = cookie.serialize(key, value, options);
    document.cookie = cookieToSet;
  },

  unset(key) {
    this.set(key, '', -1);
  },

  get(key) {
    if (typeof document === 'undefined') {
      return null;
    }
    return cookie.parse(document.cookie)[key];
  },

};

export default Cookies;



// WEBPACK FOOTER //
// /opt/yplan/backend/yplan/website/apps/web/src/utils/cookies.js